import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';

@Injectable()
export class ForgotPassBusinessService {

  headers: Headers;
  headers2: Headers;
  url = environment.qrcode_url;
  urlReset = environment.qrcode_url_reset_pass;
  urlBusiness = environment.apiBaseUrlBusiness;

  constructor(
    private http: Http
  ) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    this.headers2 = new Headers({
      'Content-Type': 'application/json',
    });
  }

  checkAccBusiness(query?: any): Observable<any> {
    return this.http.get(`${this.url}/user/phone`, {headers: this.headers2, params: query}).map(res => {
      return res.json();
    });
  }

  pushOTPBusiness(body: any): Observable<any> {
    return this.http.post(`${this.urlBusiness}/users/send-otp`, body).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }

  sendOTPBusiness(body: any) {
    return this.http.post(`${this.urlBusiness}/users/reset-password`, body).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }

  // New

  forgotPass(query?: any): Observable<any> {
    return this.http.get(`${this.urlReset}/api/v1/noauth/password/forgot/request`, {headers: this.headers2, params: query}).map(res => {
      return res.json();
    });
  }

  forgotConfirm(body: any): Observable<any> {
    return this.http.post(`${this.urlReset}/api/v1/noauth/password/forgot/confirm`, body).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }

  forgotChange(body: any): Observable<any> {
    return this.http.post(`${this.urlReset}/api/v1/noauth/password/forgot/change`, body).map(res => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/ForgotPassBusiness.service.ts